import { Navigate } from '@exam-management/router';
import { type PropsWithChildren } from '@shared/utils';
import { matchPath, useLocation } from 'react-router-dom';

import { useQuestionReviewTaskDetails } from '../../providers';

type QuestionReviewTaskDetailsRouteControllerProps = PropsWithChildren;

export default function QuestionReviewTaskDetailsRouteController(
  props: QuestionReviewTaskDetailsRouteControllerProps,
) {
  const { children } = props;

  const { pathname } = useLocation();
  const { taskDetails } = useQuestionReviewTaskDetails();

  const matchedMyTask = matchPath('/my-task/question-review/*', pathname);
  const matchedTaskManagement = matchPath('/task-management/question-review/*', pathname);

  const isMainTask = !taskDetails.parentTask;

  if (matchedMyTask && isMainTask) {
    return <Navigate to='/access-denied' replace />;
  }

  if (matchedTaskManagement && !isMainTask) {
    return <Navigate to='/access-denied' replace />;
  }

  return children;
}
